export default (editor, config = {}) => {
  const bm = editor.BlockManager;
  // ...
}
